import React, { useMemo, useState } from "react";
import { Card, Select, Space, Typography } from "antd";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from "recharts";
import dayjs from "dayjs";

const { Title } = Typography;

const timeRanges = [
  { label: "Live", value: "live" },
  { label: "Last 1 Hour", value: "1h" },
  { label: "Last 24 Hours", value: "24h" },
];

// 🔧 mock data generator (replace with API)
const generateData = () =>
  Array.from({ length: 40 }).map((_, i) => ({
    time: dayjs().subtract(40 - i, "minute").format("HH:mm"),
    cpu: Math.random() * 30,
    read: Math.random() * 250,
    write: Math.random() * 80,
    iopsRead: Math.random() * 20,
    iopsWrite: Math.random() * 8,
  }));

export default function ServerGraphs() {
  const [range, setRange] = useState("live");

  const data = useMemo(() => generateData(), [range]);

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      {/* HEADER */}
      <Card>
        <Space
          style={{ width: "100%", justifyContent: "space-between" }}
        >
          <Title level={5} style={{ margin: 0 }}>
            GRAPHS
          </Title>

          <Select
            value={range}
            options={timeRanges}
            onChange={setRange}
            style={{ width: 140 }}
          />
        </Space>
      </Card>

      {/* CPU */}
      <Card title="CPU">
        <ResponsiveContainer width="100%" height={220}>
          <LineChart data={data}>
            <CartesianGrid stroke="#2a2a2a" />
            <XAxis dataKey="time" stroke="#888" />
            <YAxis unit="%" stroke="#888" />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="cpu"
              stroke="#e11d48"
              strokeWidth={2}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </Card>

      {/* DISK THROUGHPUT */}
      <Card title="DISK THROUGHPUT">
        <ResponsiveContainer width="100%" height={220}>
          <LineChart data={data}>
            <CartesianGrid stroke="#2a2a2a" />
            <XAxis dataKey="time" stroke="#888" />
            <YAxis unit=" KB/s" stroke="#888" />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="read"
              stroke="#facc15"
              strokeWidth={2}
              dot={false}
              name="read"
            />
            <Line
              type="monotone"
              dataKey="write"
              stroke="#ef4444"
              strokeWidth={2}
              dot={false}
              name="write"
            />
          </LineChart>
        </ResponsiveContainer>
      </Card>

      {/* DISK IOPS */}
      <Card title="DISK IOPS">
        <ResponsiveContainer width="100%" height={220}>
          <LineChart data={data}>
            <CartesianGrid stroke="#2a2a2a" />
            <XAxis dataKey="time" stroke="#888" />
            <YAxis unit=" ops" stroke="#888" />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="iopsRead"
              stroke="#facc15"
              strokeWidth={2}
              dot={false}
              name="read"
            />
            <Line
              type="monotone"
              dataKey="iopsWrite"
              stroke="#ef4444"
              strokeWidth={2}
              dot={false}
              name="write"
            />
          </LineChart>
        </ResponsiveContainer>
      </Card>
    </Space>
  );
}
